import { render } from "./StrukturView.vue?vue&type=template&id=ea802dac"
import script from "./StrukturView.vue?vue&type=script&lang=js"
export * from "./StrukturView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__